import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
	rootContainer: {
		margin: `0 ${theme.spacing(2)}px`
	},
	tooltip: {
		whiteSpace: 'pre-wrap'
	}
}));
